import React, { Component } from 'react';
import './webview.css';

import {
  ContentHeader
} from '../../components';

export default class Webview extends Component {
  render() {
    return (
      <p className="rdp-react-template-component-webview">
        <ContentHeader
          title={this.props.title}
          titleSize="15px"
          onBack={() => this.props.onBack()}
        />
        <iframe src={this.props.url} className="rdp-react-template-component-webview-iframe" title={this.props.title}></iframe>
      </p>
    );
  }
}
